import { motion } from 'framer-motion';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CustomButtons } from 'pages/custom/shared/detail/CustomButtons';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
}

export const BenatskaPage = (props: Props): JSX.Element => {
    const isWide = useIsWide();
    const ctxView = useContext(CtxView);
    const ctxModal = useContext(CtxModal);
    const analytics = useAnalytics();

    function getAnimation(delay: number) {
        const animation = {
            animate: {
                opacity: [0, 0.7, 0]
            },
            transition: {
                delay: delay,
                duration: 4,
                repeat: Infinity
            }
        };
        return animation;
    }

    return (
        <S_BenatskaPage className={props.className}>
            <CustomMapPage
                mapId={'23256f78-6042-4a3c-866e-14c62550cd1a'}
                highlightedStyle={''}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/b0df80ee-e7a9-4590-82c4-704b71ecfc3b.png',
                    link: 'https://www.benatska.cz/',
                    linkText: Localization.WEBSITE,
                    logoMarginTop: '0px',
                    logoText: 'Benátská s Impulsem',
                    logoSubtext: '29. ročník'
                }}
                controls={
                    <CustomButtons
                        buttons={[
                            {
                                label: 'Praktické info',
                                icon: { iconSet: 'far', iconName: 'building' },
                                onClick: () => {
                                    analytics.track('custom_button.clicked', {
                                        action: 'sidebar_list.opened'
                                    });
                                    ctxModal.setDetailListModal({
                                        storyIds: [
                                            '66e9cede-0594-49ee-a98b-1176af498316',
                                            '686de13c-14b6-4238-8e63-2b540752648d',
                                            '7b2d60f5-0dcb-4eb3-9d1a-b2bac03beccd'
                                        ],
                                        show: 'all'
                                    });
                                }
                            },
                            {
                                label: 'Program',
                                icon: { iconSet: 'far', iconName: 'book' },
                                onClick: () => {
                                    analytics.track('custom_button.clicked', {
                                        action: 'sidebar_programme.opened'
                                    });
                                    ctxModal.setDetailListModal({
                                        storyIds: [
                                            '7b7293f1-55a7-410a-ac5f-7217d421a085',
                                            'fff0a06d-90f0-4153-afc7-b9e470bd0efe',
                                            '3715090d-ae19-44f2-aa84-0f0300d3d316'
                                        ],
                                        sort: 'none',
                                        show: 'all'
                                    });
                                }
                            },
                            {
                                label: 'Zóny festivalu',
                                icon: { iconSet: 'far', iconName: 'party-horn' },
                                onClick: async () => {
                                    analytics.track('custom_button.clicked', {
                                        action: 'sidebar_zones.opened'
                                    });
                                    ctxModal.setDetailListModal({
                                        storyIds: [
                                            '235dad37-7637-433e-b507-df926405ff50',
                                            'f4367fc3-42c4-446a-85d3-e7f9002999d2',
                                            'e369d88a-2eaf-4ebb-9c1a-53a74538607f',
                                            '9b00baf2-61c7-4a50-9f22-77e26edaddaa',
                                            'd1aa4890-24da-4be4-91a6-4c6e266fe63e',
                                            '73b5e92f-0d30-4228-a7b9-06b96ec08c20',
                                            '5d90c395-dead-4bde-aee2-1cf30da7dba5'
                                        ],
                                        sort: 'none',
                                        show: 'all'
                                    });
                                }
                            },
                            // {
                            //     label: 'Partneři',
                            //     icon: { iconSet: 'far', iconName: 'handshake' },
                            //     onClick: async () => {
                            //         analytics.track('custom_button.clicked', {
                            //             action: 'sidebar_partners.opened'
                            //         });
                            //         const storyId = '7b2d60f5-0dcb-4eb3-9d1a-b2bac03beccd';
                            //         const detail = ctxView.allDetails.find(
                            //             (e) => e.storyId === storyId
                            //         );
                            //         ctxModal.setDetailModal({
                            //             id: storyId,
                            //             detail: detail,
                            //             markerId: null
                            //         });
                            //     }
                            // },
                            {
                                label: 'Zvýraznit',
                                icon: { iconSet: 'far', iconName: 'highlighter' },
                                onClick: () => {
                                    analytics.track('custom_button.clicked', {
                                        action: 'highlight_markers'
                                    });
                                    ctxView.setForceMarkersHighlight(
                                        !ctxView.forceMarkersHighlight
                                    );
                                }
                            }
                        ]}
                    />
                }
            />
            <S_L1 {...getAnimation(0.6)} />
            <S_L2 {...getAnimation(1.6)} />
            <S_L3 {...getAnimation(2.6)} />
            <S_L4 {...getAnimation(3.2)} />
            <S_L5 {...getAnimation(isWide ? 4 : 2)} />
            <S_L6 {...getAnimation(isWide ? 5.2 : 4)} />
        </S_BenatskaPage>
    );
};

const S_BenatskaPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;

const S_L = css`
    pointer-events: none;
    width: 409px;
    height: 1318px;
    position: absolute;
    opacity: 0;
`;

const S_L1 = styled(motion.div)`
    ${S_L};
    left: 0px;
    top: 0px;
    transform: rotate(15deg);
    background-image: url('https://dvtqxks0zalev.cloudfront.net/806a56e0-e4e9-4527-90f4-61236a3627f2.png'); //red
    @media (max-width: 1260px) {
        left: calc(50% - 204.5px);
    }
`;

const S_L2 = styled(motion.div)`
    ${S_L};
    left: 30%;
    top: -50px;
    transform: rotate(-15deg);
    background-image: url('https://dvtqxks0zalev.cloudfront.net/add76fb9-b41d-49e5-a465-92456173ecc0.png'); //blue
    @media (max-width: 1260px) {
        left: calc(50% - 204.5px);
        display: none;
    }
`;

const S_L3 = styled(motion.div)`
    ${S_L};
    left: 50%;
    top: -100px;
    transform: rotate(22deg);
    background-image: url('https://dvtqxks0zalev.cloudfront.net/f7bb895c-df73-4206-9e7a-af7ac6e0dae0.png'); //white
    @media (max-width: 1260px) {
        left: calc(50% - 204.5px);
        display: none;
    }
`;

const S_L4 = styled(motion.div)`
    ${S_L};
    /* transform: matrix(0.97, -0.25, 0.25, 0.97, 0, 0); */
    left: 80%;
    top: -150px;
    transform: rotate(5deg);
    background-image: url('https://dvtqxks0zalev.cloudfront.net/806a56e0-e4e9-4527-90f4-61236a3627f2.png'); //red
    @media (max-width: 1260px) {
        left: calc(50% - 204.5px);
        display: none;
    }
`;

const S_L5 = styled(motion.div)`
    ${S_L};
    left: 60%;
    top: -20px;
    transform: rotate(-10deg);
    background-image: url('https://dvtqxks0zalev.cloudfront.net/add76fb9-b41d-49e5-a465-92456173ecc0.png'); //blue
    @media (max-width: 1260px) {
        left: calc(65% - 204.5px);
        animation-delay: 2s;
    }
`;

const S_L6 = styled(motion.div)`
    ${S_L};
    left: 15%;
    top: -60px;
    transform: rotate(-22deg);
    animation-delay: 5.2s;
    background-image: url('https://dvtqxks0zalev.cloudfront.net/f7bb895c-df73-4206-9e7a-af7ac6e0dae0.png'); //white
    @media (max-width: 1260px) {
        left: calc(50% - 204.5px);
        animation-delay: 4s;
    }
`;
